














import { Component, Vue } from "vue-property-decorator";
import DateRangeChart from "@/components/app/global/stats/charts/_dateRangeChart.vue";
import {
  dateFormat,
  convertToDate,
  dateRangeValues,
  currencyColor
} from "@/components/app/global/stats/charts/utils";

@Component({
  components: {
    "date-range-chart": DateRangeChart
  }
})
export default class ClientsChart extends Vue {
  public getChartData({ data, params, dates }) {
    const existingDates = (data || []).map(i =>
      this.$moment(convertToDate(i.year, i.day, i.hour))
    );

    const values = (data || []).map(i => i.count || 0);
    const mappedData = dateRangeValues(
      params.group,
      dates,
      existingDates,
      values
    );
    const format = dateFormat(params.group, dates);
    const labels = mappedData.map(i => this.$moment(i.date).format(format));
    const chartData = mappedData.map(i => i.value);
    return {
      labels,
      datasets: [
        {
          label: this.$t("_.clients"),
          ...currencyColor({ index: 0 }),
          data: chartData
        }
      ]
    };
  }
}
